<template>
  <v-layout row wrap v-if="data">
    <vue-title :title="data.title" />
    <v-flex xs12 md4>
      <v-layout column>
        <v-flex ma-2>
          <FCCApplicationDetails :dataProp="this.data" :reload="this.reload" />
        </v-flex>
        <v-flex ma-2>
          <FCCApplicationPayment :data="this.data" :reload="this.reload" />
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 md8>
      <v-layout column>
        <v-flex ma-2>
          <FCCApplicationCompetitors :data="this.data" :reload="this.reload" />
        </v-flex>
        <v-flex ma-2 v-if="$store.getters['isAdministrator']">
          <FCCApplicationEvents :data="this.data" />
        </v-flex>
        <v-flex ma-2>
          <FCCApplicationRuns :data="this.data" />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDatePicker,
    VMenu,
  } from 'vuetify/lib'
  import fccapi from '../fccapi.js'
  import FCCApplicationStatus from '../components/FCCApplicationStatus'
  import FCCApplicationDetails from '../components/application/FCCApplicationDetails'
  import FCCApplicationPayment from '../components/application/FCCApplicationPayment'
  import FCCApplicationCompetitors from '../components/application/FCCApplicationCompetitors'
  import FCCApplicationEvents from '../components/application/FCCApplicationEvents'
  import FCCApplicationRuns from '../components/application/FCCApplicationRuns'

  export default {
    name: 'Application',
    data: () => ({
      drawer: null,
      dateofbirth: "",
      data: null
    }),
    computed: {
      genders: function () { 
        return [this.$t("profile.male"), this.$t("profile.female")]
      }
    },
    props: {
      source: String
    },
    components: {
      VCard,
      VTooltip,
      VForm,
      VTextField,
      VCardActions,
      VCardText,
      VSelect,
      VDatePicker,
      VMenu,
      FCCApplicationStatus,
      FCCApplicationDetails,
      FCCApplicationPayment,
      FCCApplicationCompetitors,
      FCCApplicationEvents,
      FCCApplicationRuns
    },
    methods: {
      reload: function(){
        fccapi.get('applications/'+this.$route.params.id).then((r) => {
          this.data = r.data;
        })
      }
    },
    mounted() {
      this.reload();
    }
  }
</script>